// AUTOGENERATED FILE - DO NOT MODIFY!
// This file was generated by Djinni from 009_fatmap_api_private_api.djinni
/**
 * Supported image formats
 * For RGB and RGBA formats use 8 bits per channel
 */
export var ImageFormat;
(function (ImageFormat) {
    ImageFormat[ImageFormat["JPG"] = 0] = "JPG";
    ImageFormat[ImageFormat["PNG"] = 1] = "PNG";
    ImageFormat[ImageFormat["RGB"] = 2] = "RGB";
    ImageFormat[ImageFormat["RGBA"] = 3] = "RGBA";
})(ImageFormat || (ImageFormat = {}));
